import ActionTypes from '../../../../constants/ActionTypes';
import { VoucherState } from './types';

const initialState: VoucherState = {
  code: '',
  msisdnRequired: false,
};

const voucherReducer = (state = initialState, action: any): any => {
  switch (action.type) {
  case ActionTypes.ORDER.VOUCHER.SET_VOUCHER_CODE:
    return {
      ...state,
      code: action.payload,
    };
  case ActionTypes.ORDER.VOUCHER.SET_MSISDN_REQUIRED:
    return {
      ...state,
      msisdnRequired: action.payload,
    };
  }
  return state;
};

const greenVoucherInitialState = {
  errorMessage: '',
  deviceNumberSpecified: false,
  numberOfDevices: 0,
  voucherApplied: false,
  voucherSerialNumber: '',
  voucherValue: '',
  voucherDate: '',
};

export const greenVoucherReducer = (state = greenVoucherInitialState, action: any): any => {
  switch (action.type) {
  case ActionTypes.ORDER.GREEN_VOUCHER.SET_VOUCHER_APPLIED:
    return {
      ...state,
      voucherApplied: true,
      voucherSerialNumber: action.payload.voucherSerialNumber,
      voucherValue: action.payload.voucherValue,
      voucherDate: action.payload.voucherDate,
      errorMessage: '',
    };
  case ActionTypes.ORDER.GREEN_VOUCHER.SET_VOUCHER_FAILED_MESSAGE:
    return {
      ...state,
      errorMessage: action.payload,
    };
  case ActionTypes.ORDER.GREEN_VOUCHER.SET_DEVICE_NUMBER_SPECIFIED:
    return {
      ...state,
      deviceNumberSpecified: Boolean(action.payload),
      numberOfDevices: action.payload
    };
  case ActionTypes.ORDER.GREEN_VOUCHER.CLEAR_APPLIED_VOUCHER:
    return {
      ...state,
      voucherApplied: false,
      voucherSerialNumber: '',
      voucherValue: '',
      voucherDate: '',
      errorMessage: '',
    };
  }
  return state;
};

export default voucherReducer;
